import React, {Component} from 'react'
import {Button, Drawer, Form} from 'antd';
import Swal from "sweetalert2";
import {withTourGuide} from "../guideComponent/withTourGuide";

class Edit extends Component {
    constructor() {
        super();
        this.triggerGuideOnce = this.triggerGuideOnce.bind(this);
    }

    triggerGuideOnce = (e, config) => {
        const { showGuide, isGuideActive, disabledKeys } = this.props;

        const target = e?.currentTarget ?? null;
        if (!target || !config?.key) return;
        if (disabledKeys?.includes(config.key)) return;
        if (isGuideActive) return;
        if (typeof showGuide !== 'function') return;
        showGuide(target, config);
    };


    simpanJabatan = () => {
        let form = {
            id: this.props.data.jabatan_id,
            name: this.props.data.jabatan_nama,
        }
        this.props.request("jabatan/update", form, 'POST')
            .then(response => {
                if (response && response.success) {
                    const filter_data = JSON.parse(localStorage.getItem('Presensi-Company-Data'))
                    if (filter_data && filter_data._jabatan) {
                        const updateJabatan = filter_data._jabatan.map(jabatan =>
                            jabatan.jabatan_id === this.props.data.jabatan_id ? {
                                ...jabatan,
                                jabatan_nama: this.props.data.jabatan_nama,
                            } : jabatan)
                        const updateFilter = {...filter_data, _jabatan: updateJabatan}
                        localStorage.setItem('Presensi-Company-Data', JSON.stringify(updateFilter))
                    }
                    this.setState({
                        jabatan_nama : ''
                    },() =>this.props.changeState({
                        visable: false,
                        jabatan_nama : '',
                        data: [],
                        isLoading: true,
                    },() => {
                        this.props.loadData()
                    }))
                    Swal.fire({
                        title: 'Berhasil!',
                        text: response.message,
                        icon: 'success'
                    })
                }
                if (response && response.failed) {
                    Swal.fire({
                        title: 'Gagal!',
                        text: response.message,
                        icon: 'warning',
                        confirmButtonText: 'OK'
                    })
                }
            });
    }


    render() {
        return (
            <Drawer
                title="Edit Jabatan"
                width={350}
                onClose={() => {
                    this.props.changeState({visable: false, jabatan_nama:''});
                }}
                visible={this.props.data.visable}
                bodyStyle={{ paddingBottom: 80 }}
                footer={
                    <div
                        style={{
                            textAlign: 'right',
                        }}
                    >
                        <Button onChange={() => {
                            this.props.changeState({visable: false, jabatan_nama:''});
                        }}
                                style={{ marginRight: 8 }}>
                            Batal
                        </Button>
                        <Button onClick={this.simpanJabatan} type="primary">
                            Simpan
                        </Button>
                    </div>
                }
            >
                <Form layout="vertical" hideRequiredMark>
                    <div className="form-group">
                        <label>Nama Jabatan</label>
                        <input name="jabatan_nama" className="form-control col-xl-12 col-md-12" placeholder="Nama Jabatan..."
                               type="text" required="" value={this.props.data.jabatan_nama}
                               onChange={(event) => {
                                   const target = event.target;
                                   const value  = target.value;
                                   const name   = target.name;
                                   this.props.changeState({
                                       [name]: value
                                   });
                               }}
                               onPointerEnter={(e) => {
                                   this.triggerGuideOnce(e, {
                                       key: "namaJabatanEdit",
                                       title: "Nama Jabatan",
                                       content: "Masukkan nama jabatan yang akan dibuat. Contoh: Manager, Supervisor, Staff IT, atau posisi lainnya sesuai struktur organisasi."
                                   });
                               }}
                        />
                    </div>
                </Form>
            </Drawer>

        )
    }
}

export default withTourGuide(Edit)
